// extracted by mini-css-extract-plugin
module.exports = {"card":"authorization-form_card__FMDWE","form":"authorization-form_form__aEPUm","field":"authorization-form_field__4jds9","submitButton":"authorization-form_submitButton__81GU8"};